export class SelectView {
  constructor(
    private id: number,
    private name: string
  ) {}
}
